import axios from "axios";

// Make sure this matches your backend URL
const API_URL = "https://ims.holdthechild.net/api/programstaff"; 

export const getDashboardData = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    // Handle unauthenticated state on the client side
    console.error("No authentication token found.");
    return null;
  }

  try {
    const response = await axios.get(`${API_URL}/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    // You can also check for specific error codes, like 401 for unauthorized
    if (error.response && error.response.status === 401) {
      // e.g., redirect to login page
    }
    return null;
  }
};